import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';

import { lastValueFrom } from 'rxjs';

export interface AppConfig {
	adfsURL: string;
	authURL: string;
	passwordUpdateUrl?: string;
	openReplayEnabled: 'true' | 'false';
	openReplayProjectKey?: string;
}

declare global {
	interface Window {
		authURL: string;
		openReplayEnabled: 'true' | 'false';
		openReplayProjectKey?: string;
	}
}

@Injectable({ providedIn: 'root' })
export class AppConfigService {
	private config?: AppConfig;
	private configPromise: Promise<void> | null = null;
	loaded = false;

	constructor(private readonly http: HttpClient) {}

	loadConfig(): Promise<void> {
		if (this.configPromise === null) {
			this.configPromise = lastValueFrom(this.http.get<AppConfig>('/assets/app.config.json')).then((data) => {
				this.config = data;
				window.authURL = data.authURL;
				window.openReplayEnabled = data.openReplayEnabled;
				window.openReplayProjectKey = data.openReplayProjectKey;
				this.loaded = true;
			});
		}
		return this.configPromise;
	}

	getConfig(): AppConfig | undefined {
		return this.config;
	}
}
